import styled, {css} from "styled-components";
import {GamePlayPcHeaderBarRealMoneyLabelDefaultBox} from "./game-play-pc-header-bar-real-money-label.default.box";


export const GamePlayPcHeaderBarRealMoneyLabelCasino777Box = styled(GamePlayPcHeaderBarRealMoneyLabelDefaultBox)`
  ${
    props => props.isInRealMode
        ? css`
              color: ${props => props.theme.colors.dangerDark};
            `
        : css`
              color: ${props => props.theme.colors.textActive};
        `
}
`